module.exports = __webpack_public_path__ + "static/media/house-0.73d6f233.jpg";